import { BaseMutations } from '@/store/base-mutations';
import { PurchaseOrders } from '@/modules/purchase-orders/types';
import FilesState from './state';

export default class FilesMutations extends BaseMutations<FilesState> {
  SET_FILES(files: PurchaseOrders.File[]) {
    this.state.files = files;
  }

  SET_FILE(file: any) {
    this.state.file = file;
  }

  ADD_FILE(file: PurchaseOrders.File) {
    this.state.files.push(file);
  }

  TOGGLE_LOADING_FILES(toggle: boolean) {
    this.state.loading = toggle;
  }
}
